export class OrderGlobals {
    static CONTEXT: Record<string, string> = {
        BASKET: 'Warenkorb',
        CHECKOUT: 'Checkout'
    };

    static initialize() {
        const o_order = window.o_order ?? {};
        o_order.globals = o_order.globals ?? {};
        o_order.globals.CONTEXT = OrderGlobals.CONTEXT
    }
}
